import { defineStore } from 'pinia'
import { useFetch } from '@/modules/core/composables/useFetch'
import { ref } from 'vue'

export const useGroupStore = defineStore('public/groupStore', () => {
  const errorMessage = ref(null)

  const createGroup = async (payload: {}) => {
    try {
      await useFetch(`/v4/public/groups/register`).post(payload)
    } catch (err) {
      errorMessage.value = err.message || 'An error occurred while creating the group.'
    }
  }

  const clearErrorMessage = () => {
    errorMessage.value = null
  }

  return {
    createGroup,
    errorMessage,
    clearErrorMessage,
  }
})
